import { ProductAvailability, QueryOptions } from "../models";
import { Product } from "../models/Product";
import { Client, Enumerable, ResourceId } from "../types/internal";
import { omitData } from "../utils/data";

export const createProduct = (client: Client) => ({
  retrieve: (id: ResourceId, fields?: Enumerable<string>) => {
    return client
      .retrieve<Product>(["products", id], fields)
      .then((result) => ({
        ...omitData(result),
        product: result.data,
      }));
  },
  availability: (handle: ResourceId) => {
    return client.availability<ProductAvailability>("products", handle);
  },
  list: (options?: QueryOptions) => {
    return client.list<Product[]>("products", options).then((result) => ({
      ...omitData(result),
      products: result.data,
    }));
  },
});
